import React from "react";

const BottomArrowIcon: React.FunctionComponent = () => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00012 1L5.92941 5.92929C5.96846 5.96834 6.03178 5.96834 6.07083 5.92929L11.0001 1"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default React.memo(BottomArrowIcon);
